<template>
  <Modal
    ref="modal"
    width="620px"
    class="info-modal"
  >
    <template #header>
      <p class="bold has-text-size-18 m-0 info-title">
        {{ $t("bnpl:limit.login.info.title") }}
      </p>
    </template>
    <template #default="{ close }">
      <div class="flex-column gap-20">
        <p class="has-text-grey">
          {{ $t("bnpl:limit.login.info.description") }}
        </p>
        <div class="flex-column gap-16">
          <div
            v-for="item in items"
            :key="item"
            class="info-item"
          >
            <div class="info-check">
              <IconsCheck />
            </div>
            <p>{{ $t(item) }}</p>
          </div>
        </div>
        <button
          class="btn btnL stretch"
          @click="close"
        >
          {{ $t("bnpl:limit.login.info.button") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
const items = [
  "bnpl:limit.login.info.item1",
  "bnpl:limit.login.info.item2",
  "bnpl:limit.login.info.item3",
  "bnpl:limit.login.info.item4",
];

const modal = ref(null);

function open() {
  modal.value.open();
}

defineExpose({ open });
</script>

<style scoped lang="scss">
.info-modal {
  :deep(.modal) {
    padding: 20px;
  }

  // the header slot is a plain flex child, so the title only centers between the
  // edges once it grows - the padding offsets the close button on the other side
  :deep(.modal-header > div:first-child) {
    flex-grow: 1;
    padding-left: 24px;
    text-align: center;
  }
}

.info-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
}

.info-check {
  width: 26px;
  min-width: 26px;
  height: 26px;
  border-radius: 999999px;
  background: var(--brandPrimary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    display: block;
  }
}

@media only screen and (max-width: 792px) {
  .info-modal :deep(.modal-header > div:first-child) {
    padding-left: 0;
    text-align: left;
  }
}
</style>
